module.exports = __webpack_public_path__ + "media/images/dashboard/wedding_styles/clasic1-ba8754a3214033cf4bbefc174a6cea90.jpg";